shadow$provide[488] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Join:{enumerable:true, get:function() {
  return Join;
}}});
var require$_DOT__SLASH_block = require("./block");
class Join extends require$_DOT__SLASH_block.Block {
  constructor(nodes) {
    super(true);
    this.nodes = nodes;
    this.construct();
  }
  clone() {
    return new Join(this.nodes);
  }
  makeOutlets() {
    return [];
  }
  call(program, depth) {
    return (() => {
      const result = [];
      for (const node of Array.from(this.nodes)) {
        const block = node.owner;
        result.push(block.call(program, depth));
      }
      return result;
    })();
  }
  export(layout, depth) {
    return (() => {
      const result = [];
      for (const node of Array.from(this.nodes)) {
        const block = node.owner;
        result.push(block.export(layout, depth));
      }
      return result;
    })();
  }
}

};